import { cn } from "../lib/cn";
import type { ExperienceItem } from "../data/portfolio";

interface TimelineItemProps extends ExperienceItem {
  index: number;
  last: boolean;
}

/** One entry on the experience rail: blue node, period column, role + highlights. */
export function TimelineItem({
  period,
  index,
  role,
  organization,
  summary,
  highlights,
  last,
}: TimelineItemProps) {
  return (
    <article className={cn("relative", !last && "pb-12")}>
      <span
        aria-hidden="true"
        className="absolute top-1 -left-[calc(2.25rem+5px)] size-3.5 rounded-full border-4 border-page bg-blue-400"
      />
      <div className="grid gap-3 lg:grid-cols-[12rem_minmax(0,1fr)] lg:gap-8">
        <div>
          <p className="text-accent-strong text-sm font-semibold">{period}</p>
          <p className="text-muted mt-1 text-sm">
            {String(index).padStart(2, "0")}
          </p>
        </div>
        <div className="max-w-3xl">
          <h3 className="text-strong text-xl font-semibold">{role}</h3>
          <p className="text-muted mt-1 font-medium">{organization}</p>
          {summary ? (
            <p className="text-body mt-4 leading-7">{summary}</p>
          ) : null}
          {highlights.length ? (
            <ul className="mt-5 grid gap-2">
              {highlights.map((highlight) => (
                <li
                  key={highlight}
                  className="text-muted flex gap-3 text-sm leading-6"
                >
                  <span
                    aria-hidden="true"
                    className="mt-2.5 h-px w-4 shrink-0 bg-zinc-600"
                  />
                  {highlight}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    </article>
  );
}
